import styled from "styled-components";
import { bodyColor } from "../../../../../config/constants";

export const MainDiv = styled.div`
  width: 100%;
  background-color: #fff;
  border-radius: 5px;
`;
export const Header = styled.div`
  padding: 9px;
  width: 100%;
  min-height: 48px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: ${({ background }) => background && background};
  border-radius: 5px 5px 0 0;
`;
export const Title = styled.p`
  font-size: 14px;
  font-weight: 600;
  color: #fff;
`;
export const Body = styled.div`
  padding: 16px;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: #fff;
  border-radius: 0 0 5px 5px;
  gap: 24px;
`;
export const Form = styled.div`
  width: 90%;
  display: flex;
  flex-direction: column;
  gap: 8px;
`;
export const InputDataDiv = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;
`;
export const Label = styled.label`
  font-size: 14px;
  font-weight: 500;
  text-align: right;
  color: ${({ isDisabled }) => (isDisabled ? "#808080" : "#000")};
`;
export const AgeDiv = styled.div`
  width: 190px;
  display: flex;
  justify-content: space-between;
  gap: 4px;
`;
export const Input = styled.input`
  padding: 5px 10px;
  width: 100%;
  border: 1px solid ${bodyColor};
  outline: none;
  border-radius: 5px;
  font-size: 14px;
`;
export const SubmitButton = styled.button`
  padding: 10px 16px;
  border: none;
  border-radius: 5px;
  color: #fff;
  font-size: 14px;
  font-weight: 600;
  text-align: center;
  background-color: ${({ background }) => background && background};
  outline: none;
  cursor: pointer;
  pointer-events: ${({ disabled }) => (disabled ? "none" : "auto")};
`;
